import React, { useEffect, useState } from "react";
import {
  Button,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  FormHelperText,
  TextField,
  Tooltip,
} from "@mui/material";
import apiService from "../../api/apiService";
import { useNavigate, useParams } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
const MemberDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  let ids;
  if (id) {
    ids = atob(id);
  }
  const [userData, setUserData] = useState({});
  const {
    handleSubmit,
    control,
    formState: { errors },
    watch,
    setValue,
    getValues,
    clearErrors,
  } = useForm({ values: userData, mode: "onBlur" });
  useEffect(() => {
    handleClickView();
  }, []);
  const beneficialActivity = watch("beneficialActivity");
  // const sportsPlayer = watch("sportsPlayer", false);
  // const traditionalArt = watch("traditionalArt", false);
  // const computerSkill = watch("computerSkill", false);
  const handleClickView = () => {
    apiService(`user/get?id=${ids}`, "", "get")
      .then((result) => {
        if (result?.data) {
          let values = result.data;
          values.gramaSaba =
            values.gramaSaba === true
              ? "Yes"
              : values.gramaSaba === false && "No";
          values.treePlanting =
            values.treePlanting === true
              ? "Yes"
              : values.treePlanting === false && "No";

          // if (values.treePlanting) {
          //   values.treePlanting = values.treePlanting ? "Yes" : "No";
          // }
          values.beneficialActivity =
            values.beneficialActivity === true
              ? "Yes"
              : values.beneficialActivity === false && "No";
          // if (values.beneficialActivity) {
          //   values.beneficialActivity = values.beneficialActivity
          //     ? "Yes"
          //     : "No";
          // }
          values.libraryVisitor =
            values.libraryVisitor === true
              ? "Yes"
              : values.libraryVisitor === false && "No";
          // if (values.libraryVisitor) {
          //   values.libraryVisitor = values.libraryVisitor ? "Yes" : "No";
          // }
          values.sportsGames =
            values.sportsGames === true
              ? "Yes"
              : values.sportsGames === false && "No";
          // if (values.sportsGames) {
          //   values.sportsGames = values.sportsGames ? "Yes" : "No";
          // }
          values.artCulture =
            values.artCulture === true
              ? "Yes"
              : values.artCulture === false && "No";
          // if (values.artCulture) {
          //   values.artCulture = values.artCulture ? "Yes" : "No";
          // }
          // sport: data.sport,

          // values.gramaSaba = values.gramaSaba ? values.gramaSaba : "No";
          // values.treePlanting = values?.treePlanting
          //   ? values.treePlanting
          //   : "No";
          // values.beneficialActivity = values.beneficialActivity
          //   ? values.beneficialActivity
          //   : "No";
          // values.beneficialActivityName = values.beneficialActivityName
          //   ? values.beneficialActivityName
          //   : "No";
          // values.libraryVisitor = values.libraryVisitor
          //   ? values.libraryVisitor
          //   : "No";
          setUserData(values);
        }
      })
      .catch((err) => {});
  };

  const handleViewClose = () => {
    navigate("/admin/list");
  };
  const onSubmit = (data) => {
    console.log(data);
    //     gramaSaba
    // treePlanting
    // beneficialActivity
    // beneficialActivityName
    // libraryVisitor
    // sportsPlayer
    // sport
    // traditionalArt
    // artName
    let req = {
      id: data.id,
      gramaSaba: data.gramaSaba === "Yes" ? true : false,
      treePlanting: data.treePlanting === "Yes" ? true : false,
      beneficialActivity: data.beneficialActivity === "Yes" ? true : false,
      beneficialActivityName: data.beneficialActivityName,
      libraryVisitor: data.libraryVisitor === "Yes" ? true : false,
      sportsGames: data.sportsGames === "Yes" ? true : false,
      // sport: data.sport,
      artCulture: data.artCulture === "Yes" ? true : false,
      // artName: data.artName,
      status: 1,
    };
    apiService("user/status/update", req, "post")
      .then((result) => {
        if (result?.data?.responseStatus === "Success") {
          handleClickOpen();
        }
      })
      .catch((err) => {});
  };
  const onError = (even) => {
    console.log(even);
  };
  const handleApprove = (id) => {
    let req = {
      id: id,
      status: 1,
    };
    apiService("user/status/update", req, "post")
      .then((result) => {
        if (result?.data?.responseStatus === "Success") {
          handleClickOpen();
        }
      })
      .catch((err) => {});
  };
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
    setTimeout(() => {
      handleClose();
    }, 1500);
  };
  const handleClose = () => {
    setOpen(false);
    handleViewClose();
  };
  const handleDataStatus = (name, val) => {
    // debugger;
    setValue(name, val);
    clearErrors(name);
  };

  return (
    <>
      <div style={{ paddingBottom: "50px" }}>
        <Container maxWidth="xl">
          <h5 className="mb-3">Member Details</h5>

          <div className="table-div">
            <form
              className="login-form validate-form"
              onSubmit={handleSubmit(onSubmit, onError)}
            >
              <div>
                <div className="member-section">
                  <p className="d-flex">
                    <b>Personal Details</b>
                    <span className="ml-auto">
                      Score : <b>{userData?.score}</b>
                    </span>
                  </p>
                  <Divider className="mb-4" />
                  <div className="row">
                    <div className="col-lg-9 col-md-9 col-12 order-2 order-md-1">
                      <div className="row">
                        <div className="col-lg-4 col-md-6 col-12">
                          <p className="d-flex">
                            Name:{" "}
                            <b className="ml-auto c-blue">{userData?.name}</b>
                          </p>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                          <p className="d-flex">
                            Mobile Number:{" "}
                            <b className="ml-auto c-blue">{userData?.phone}</b>
                          </p>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                          <p className="d-flex">
                            Email:{" "}
                            <b className="ml-auto c-blue">
                              {userData?.email ? userData?.email : "-"}
                            </b>
                          </p>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                          <p className="d-flex">
                            Gender:{" "}
                            <b className="ml-auto c-blue">{userData?.gender}</b>
                          </p>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                          <p className="d-flex">
                            DOB:{" "}
                            <b className="ml-auto c-blue">{userData?.dob}</b>
                          </p>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                          <p className="d-flex">
                            Age:{" "}
                            <b className="ml-auto c-blue">{userData?.age}</b>
                          </p>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                          <p className="d-flex">
                            Father / Mother / Guardian Name:{" "}
                            <b className="ml-auto c-blue">
                              {userData?.fatherName}
                            </b>
                          </p>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12">
                          <p className="d-flex">
                            Education:{" "}
                            <b className="ml-auto c-blue">
                              {userData?.education}
                            </b>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-12 text-center order-1 order-md-2">
                      <div className="logo_div">
                        <img
                          src={
                            userData?.imageName
                              ? userData?.imageName
                              : "./images/user.png"
                          }
                          className="user_logo"
                          alt={""}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="member-section">
                  <p>
                    <b>Address Details</b>
                  </p>
                  <Divider className="mb-4" />
                  <div className="row">
                    <div className="col-lg-4 col-md-6 col-12">
                      <p className="d-flex">
                        Address:{" "}
                        <b className="ml-auto c-blue">{userData?.address}</b>
                      </p>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12">
                      <p className="d-flex">
                        District:{" "}
                        <b className="ml-auto c-blue">{userData?.district}</b>
                      </p>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12">
                      <p className="d-flex">
                        Taluk / Block:{" "}
                        <b className="ml-auto c-blue">{userData?.taluk}</b>
                      </p>
                    </div>

                    <div className="col-lg-4 col-md-6 col-12">
                      <p className="d-flex">
                        Area Type:{" "}
                        <b className="ml-auto c-blue">{userData?.areaType}</b>
                      </p>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12">
                      <p className="d-flex">
                        Village / Ward No:{" "}
                        <b className="ml-auto c-blue">{userData?.village}</b>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="member-section">
                  <p>
                    <b>Additional Details</b>
                  </p>
                  <Divider className="mb-4" />
                  <div className="row">
                    <div className="col-lg-4 col-md-6 col-12">
                      <p className="d-flex">
                        Education:{" "}
                        <b className="ml-auto c-blue">{userData?.education}</b>
                      </p>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12">
                      <p className="d-flex">
                        Community:{" "}
                        <b className="ml-auto c-blue">{userData?.community}</b>
                      </p>
                    </div>

                    <div className="col-lg-4 col-md-6 col-12">
                      <p className="d-flex">
                        During School/College Days are you member of:{" "}
                        <b className="ml-auto c-blue">
                          {userData?.memberOf !== "Others Specify"
                            ? userData?.memberOf
                            : userData?.memberOfOther}
                        </b>
                      </p>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12">
                      <p className="d-flex">
                        Area of Interest:{" "}
                        <b className="ml-auto c-blue">
                          {userData?.areaOfInterest?.join(", ")}
                        </b>
                      </p>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12">
                      <p className="d-flex">
                        Differently Abled :
                        <b className="ml-auto c-blue">
                          {userData?.differentlyAbled ? "Yes" : "No"}
                        </b>
                      </p>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12">
                      <p className="d-flex">
                        Artisian :
                        <b className="ml-auto c-blue">
                          {userData?.artisian ? "Yes" : "No"}
                        </b>
                      </p>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12">
                      <p className="d-flex">
                        Writer :
                        <b className="ml-auto c-blue">
                          {userData?.writer ? "Yes" : "No"}
                        </b>
                      </p>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12">
                      <p className="d-flex">
                        Speaker :
                        <b className="ml-auto c-blue">
                          {userData?.speaker ? "Yes" : "No"}
                        </b>
                      </p>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12">
                      <p className="d-flex">
                        Social Worker :
                        <b className="ml-auto c-blue">
                          {userData?.socialWorker ? "Yes" : "No"}
                        </b>
                      </p>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12">
                      <p className="d-flex">
                        Certified Librarian :
                        <b className="ml-auto c-blue">
                          {userData?.certLibrarian ? "Yes" : "No"}
                        </b>
                      </p>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12">
                      <p className="d-flex">
                        Computer Skill :
                        <b className="ml-auto c-blue">
                          {userData?.computerSkill ? "Yes" : "No"}
                        </b>
                      </p>
                    </div>
                    {userData?.computerSkill && (
                      <div className="col-lg-4 col-md-6 col-12">
                        <p className="d-flex">
                          Computer Skill Name :
                          <b className="ml-auto c-blue">
                            {userData?.computerSkillName}
                          </b>
                        </p>
                      </div>
                    )}
                    <div className="col-lg-4 col-md-6 col-12">
                      <p className="d-flex">
                        NSS :
                        <b className="ml-auto c-blue">
                          {userData?.nss ? "Yes" : "No"}
                        </b>
                      </p>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12">
                      <p className="d-flex">
                        NCC :
                        <b className="ml-auto c-blue">
                          {userData?.ncc ? "Yes" : "No"}
                        </b>
                      </p>
                    </div>
                    <div className="col-lg-4 col-md-6 col-12">
                      <p className="d-flex">
                        Sports Player :
                        <b className="ml-auto c-blue">
                          {userData?.sportsPlayer ? "Yes" : "No"}
                        </b>
                      </p>
                    </div>
                    {userData?.sportsPlayer && (
                      <div className="col-lg-4 col-md-6 col-12">
                        <p className="d-flex">
                          Sports Name :
                          <b className="ml-auto c-blue">{userData?.sport}</b>
                        </p>
                      </div>
                    )}
                    <div className="col-lg-4 col-md-6 col-12">
                      <p className="d-flex">
                        Traditional Art Performer:
                        <b className="ml-auto c-blue">
                          {userData?.traditionalArt ? "Yes" : "No"}
                        </b>
                      </p>
                    </div>
                    {userData?.traditionalArt && (
                      <div className="col-lg-4 col-md-6 col-12">
                        <p className="d-flex">
                          Art Name :
                          <b className="ml-auto c-blue">{userData?.artName}</b>
                        </p>
                      </div>
                    )}
                  </div>
                </div>
                <div className="member-section">
                  <p>
                    <b>Community Involvement</b>
                  </p>
                  <Divider className="mb-4" />
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-12">
                      <p className="d-flex align-items-end">
                        Whether the applicant attends Grama sabha &#8202;&#8202;
                        <span className="text-danger">*</span>&#8202;&#8202;:
                        <span className="ml-auto">
                          <Controller
                            name={`gramaSaba`}
                            control={control}
                            defaultValue=""
                            rules={{ required: "Required" }} // Display custom error message
                            render={({ field }) => (
                              <div className="p-relative yesNo_input">
                                <span
                                  className={
                                    getValues(`gramaSaba`) === "Yes"
                                      ? "yesNospan yesAct"
                                      : "yesNospan"
                                  }
                                  onClick={() => {
                                    userData?.status === 0 &&
                                      handleDataStatus("gramaSaba", "Yes");
                                  }}
                                >
                                  Yes
                                </span>
                                <span
                                  className={
                                    getValues(`gramaSaba`) === "No"
                                      ? "yesNospan noAct"
                                      : "yesNospan"
                                  }
                                  onClick={() => {
                                    userData?.status === 0 &&
                                      handleDataStatus("gramaSaba", "No");
                                  }}
                                >
                                  No
                                </span>
                              </div>
                            )}
                          />
                          <FormHelperText className="text-danger">
                            {errors.gramaSaba?.message}
                          </FormHelperText>
                        </span>
                        {/* <b className="ml-auto c-blue">{userData?.education}</b> */}
                      </p>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12"></div>
                    <div className="col-lg-6 col-md-6 col-12">
                      <p className="d-flex align-items-end">
                        Whether the applicant take part in Tree planting :{" "}
                        <span className="ml-auto">
                          <Controller
                            name={`treePlanting`}
                            control={control}
                            defaultValue=""
                            rules={{ required: "Required" }} // Display custom error message
                            render={({ field }) => (
                              <div className="p-relative yesNo_input">
                                <span
                                  className={
                                    getValues(`treePlanting`) === "Yes"
                                      ? "yesNospan yesAct"
                                      : "yesNospan"
                                  }
                                  onClick={() => {
                                    userData?.status === 0 &&
                                      handleDataStatus("treePlanting", "Yes");
                                  }}
                                >
                                  Yes
                                </span>
                                <span
                                  className={
                                    getValues(`treePlanting`) === "No"
                                      ? "yesNospan noAct"
                                      : "yesNospan"
                                  }
                                  onClick={() => {
                                    userData?.status === 0 &&
                                      handleDataStatus("treePlanting", "No");
                                  }}
                                >
                                  No
                                </span>
                              </div>
                            )}
                          />
                          <FormHelperText className="text-danger">
                            {errors.treePlanting?.message}
                          </FormHelperText>
                        </span>
                        {/* <b className="ml-auto c-blue">{userData?.education}</b> */}
                      </p>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12"></div>
                    <div className="col-lg-6 col-md-6 col-12">
                      <p className="d-flex align-items-end">
                        Whether the applicant organise (or a part of organsing
                        Committee) any activities that benefit their local
                        area. (pl mention) :{" "}
                        <span className="ml-auto">
                          <Controller
                            name={`beneficialActivity`}
                            control={control}
                            defaultValue=""
                            rules={{ required: "Required" }} // Display custom error message
                            render={({ field }) => (
                              <div className="p-relative yesNo_input">
                                <span
                                  className={
                                    getValues(`beneficialActivity`) === "Yes"
                                      ? "yesNospan yesAct"
                                      : "yesNospan"
                                  }
                                  onClick={() => {
                                    userData?.status === 0 &&
                                      handleDataStatus(
                                        "beneficialActivity",
                                        "Yes"
                                      );
                                  }}
                                >
                                  Yes
                                </span>
                                <span
                                  className={
                                    getValues(`beneficialActivity`) === "No"
                                      ? "yesNospan noAct"
                                      : "yesNospan"
                                  }
                                  onClick={() => {
                                    userData?.status === 0 &&
                                      handleDataStatus(
                                        "beneficialActivity",
                                        "No"
                                      );
                                  }}
                                >
                                  No
                                </span>
                              </div>
                            )}
                          />
                          <FormHelperText className="text-danger">
                            {errors.beneficialActivity?.message}
                          </FormHelperText>
                        </span>
                        {/* <b className="ml-auto c-blue">{userData?.education}</b> */}
                      </p>
                    </div>
                    {beneficialActivity === "Yes" && (
                      <div className="col-lg-6 col-md-6 col-12">
                        <div className="form-group">
                          <Controller
                            name="beneficialActivityName"
                            control={control}
                            defaultValue=""
                            rules={{
                              required: "Activity Details is required",
                            }}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Activity Details *"
                                placeholder="Enter Activity Details"
                                error={!!errors.beneficialActivityName}
                                helperText={
                                  errors.beneficialActivityName?.message
                                }
                                fullWidth
                                disabled={userData?.status !== 0}
                              />
                            )}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="member-section">
                  <p>
                    <b>Activity Participation</b>
                  </p>
                  <Divider className="mb-4" />
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-12">
                      <p className="d-flex align-items-end">
                        Whether the applicant participated in Sports & games :{" "}
                        <span className="ml-auto">
                          <Controller
                            name={`sportsGames`}
                            control={control}
                            defaultValue=""
                            rules={{ required: "Required" }} // Display custom error message
                            render={({ field }) => (
                              <div className="p-relative yesNo_input">
                                <span
                                  className={
                                    getValues(`sportsGames`) === "Yes"
                                      ? "yesNospan yesAct"
                                      : "yesNospan"
                                  }
                                  onClick={() => {
                                    userData?.status === 0 &&
                                      handleDataStatus("sportsGames", "Yes");
                                  }}
                                >
                                  Yes
                                </span>
                                <span
                                  className={
                                    getValues(`sportsGames`) === "No"
                                      ? "yesNospan noAct"
                                      : "yesNospan"
                                  }
                                  onClick={() => {
                                    userData?.status === 0 &&
                                      handleDataStatus("sportsGames", "No");
                                  }}
                                >
                                  No
                                </span>
                              </div>
                            )}
                          />
                          <FormHelperText className="text-danger">
                            {errors.sportsGames?.message}
                          </FormHelperText>
                        </span>
                        {/* <b className="ml-auto c-blue">{userData?.education}</b> */}
                      </p>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12"></div>
                    <div className="col-lg-6 col-md-6 col-12">
                      <p className="d-flex align-items-end">
                        Whether the applicant involves in Arts and culture
                        activities (participation in youth festival) :{" "}
                        <span className="ml-auto">
                          <Controller
                            name={`artCulture`}
                            control={control}
                            defaultValue=""
                            rules={{ required: "Required" }} // Display custom error message
                            render={({ field }) => (
                              <div className="p-relative yesNo_input">
                                <span
                                  className={
                                    getValues(`artCulture`) === "Yes"
                                      ? "yesNospan yesAct"
                                      : "yesNospan"
                                  }
                                  onClick={() => {
                                    userData?.status === 0 &&
                                      handleDataStatus("artCulture", "Yes");
                                  }}
                                >
                                  Yes
                                </span>
                                <span
                                  className={
                                    getValues(`artCulture`) === "No"
                                      ? "yesNospan noAct"
                                      : "yesNospan"
                                  }
                                  onClick={() => {
                                    userData?.status === 0 &&
                                      handleDataStatus("artCulture", "No");
                                  }}
                                >
                                  No
                                </span>
                              </div>
                            )}
                          />
                          <FormHelperText className="text-danger">
                            {errors.artCulture?.message}
                          </FormHelperText>
                        </span>
                        {/* <b className="ml-auto c-blue">{userData?.education}</b> */}
                      </p>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12"></div>
                    <div className="col-lg-6 col-md-6 col-12">
                      <p className="d-flex">
                        Whether the applicant is a regular visitor to the local
                        library :{" "}
                        <span className="ml-auto">
                          <Controller
                            name={`libraryVisitor`}
                            control={control}
                            defaultValue=""
                            rules={{ required: "Required" }} // Display custom error message
                            render={({ field }) => (
                              <div className="p-relative yesNo_input">
                                <span
                                  className={
                                    getValues(`libraryVisitor`) === "Yes"
                                      ? "yesNospan yesAct"
                                      : "yesNospan"
                                  }
                                  onClick={() => {
                                    userData?.status === 0 &&
                                      handleDataStatus("libraryVisitor", "Yes");
                                  }}
                                >
                                  Yes
                                </span>
                                <span
                                  className={
                                    getValues(`libraryVisitor`) === "No"
                                      ? "yesNospan noAct"
                                      : "yesNospan"
                                  }
                                  onClick={() => {
                                    userData?.status === 0 &&
                                      handleDataStatus("libraryVisitor", "No");
                                  }}
                                >
                                  No
                                </span>
                              </div>
                            )}
                          />
                          <FormHelperText className="text-danger">
                            {errors.libraryVisitor?.message}
                          </FormHelperText>
                        </span>
                        {/* <b className="ml-auto c-blue">{userData?.education}</b> */}
                      </p>
                    </div>

                    {/* {sportsPlayer && (
                      <div className="col-lg-3 col-md-4 col-12">
                        <div className="form-group">
                          <Controller
                            name="sport"
                            control={control}
                            defaultValue=""
                            rules={{
                              required: "Sport Name is required",
                            }}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Sport Name *"
                                placeholder="Enter Sport Name"
                                error={!!errors.sport}
                                helperText={errors.sport?.message}
                                fullWidth
                                disabled={userData?.status !== 0}
                              />
                            )}
                          />
                        </div>
                      </div>
                    )}
                    {traditionalArt && (
                      <div className="col-lg-3 col-md-4 col-12">
                        <div className="form-group">
                          <Controller
                            name="artName"
                            control={control}
                            defaultValue=""
                            rules={{
                              required: "Art Name is required",
                            }}
                            render={({ field }) => (
                              <TextField
                                {...field}
                                label="Art Name *"
                                fullWidth
                                placeholder="Enter Art Name"
                                error={!!errors.artName}
                                helperText={errors.artName?.message}
                                disabled={userData?.status !== 0}
                              />
                            )}
                          />
                        </div>
                      </div>
                    )} */}
                  </div>
                </div>
              </div>
              <div className="text-center p-4">
                <Button
                  variant="outlined"
                  color="error"
                  onClick={handleViewClose}
                  className="mr-3"
                >
                  Close
                </Button>
                {userData?.status === 0 && (
                  <Button
                    variant="contained"
                    color="success"
                    type="submit"
                    // onClick={() => handleApprove(userData.id)}
                  >
                    Provisional Approve
                  </Button>
                )}
              </div>
            </form>
          </div>
          {/* <div className="m-5">.</div> */}
        </Container>
      </div>
      {/* Dialog for Approval Message */}
      <Dialog
        fullWidth={true}
        maxWidth={"xs"}
        open={open}
        onClose={handleClose}
      >
        <DialogContent>
          <div className="text-center">
            <img src={"/images/success.gif"} alt="" className="sucess-image" />
            <h4>Approved..!!</h4>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default MemberDetails;
